import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  content: {
    paddingHorizontal: theme.spacing[5],
    paddingBottom: theme.spacing[10],
    gap: theme.spacing[4],
  },
  addonList: {
    gap: theme.spacing[2],
  },
  addonItem: {
    height: 35,
    paddingHorizontal: theme.spacing[3],
    paddingVertical: theme.spacing[3],
    borderRadius: theme.borderRadius.s,
    backgroundColor: colors.backgroundL2Alpha,
    justifyContent: 'center',
  },
  confirmButton: {
    backgroundColor: colors.backgroundNegative,
  },
  buttonsContainer: {
    gap: theme.spacing[3],
    marginTop: theme.spacing[4],
  },
}));
